<template>
  <div class="monitor-container">
    <!-- 标签页区域 -->
    <el-tabs 
      v-model="activeTab" 
      type="card"                
      tab-position="left"
      @tab-change="handleTabChange"
    > 
      <!-- 系统图Tab页 -->
      <el-tab-pane name="1" :label="renderTabLabel(slaveTabs[0])" >
        <ClientDeviceMonitorSystemMonitorSystem
          v-if="activeTab === '1'"
          :businessId = "props.businessId"
          :projectId="props.projectId"
          :collectionId="props.collectionId"
          :domainMenuId="props.domainMenuId"   
          :domainId="currentDomainId"                       
        />
      </el-tab-pane>
      
      <!-- 运行参数Tab页 -->
      <el-tab-pane name="2" :label="renderTabLabel(slaveTabs[1])">
        <div class="page-content">
        <ClientDeviceMonitorSystemMonitorOperation 
          v-if="activeTab === '2'"
          :businessId = "props.businessId"
          :projectId="props.projectId"
          :collectionId="props.collectionId"
          :domainMenuId="props.domainMenuId"   
          :domainId="currentDomainId"    
        />
        </div>
      </el-tab-pane>
      <!---报警--->
      <el-tab-pane name="3" :label="renderTabLabel(slaveTabs[2])">
        <div class="page-content">
        
          <ClientDeviceMonitorSystemMonitorAlarm 
          v-if="activeTab === '3'"
          :businessId = "props.businessId"
          :projectId="props.projectId"
          :collectionId="props.collectionId"
          :domainMenuId="props.domainMenuId"   
          :domainId="currentDomainId"    
        /> 
        </div>
      </el-tab-pane>
      <!---系统设置--->
      <el-tab-pane name= "5" :label="renderTabLabel(slaveTabs[3])">
        <div class="page-content">        
          <ClientDeviceMonitorSystemMonitorOperation 
          v-if="activeTab === '5'"
          :businessId = "props.businessId"
          :projectId="props.projectId"
          :collectionId="props.collectionId"
          :domainMenuId="props.domainMenuId"   
          :domainId="currentDomainId"    
        /> 
        </div>
      </el-tab-pane>
 
      <!-- 其他设备Tab页 v-if="tabComponentMap[tab.url] && activeTab === tab.id"-->
      <el-tab-pane
        v-for="tab in otherTabs"
        :key="tab.id"
        :name="tab.id"
        :label="renderTabLabel(tab)"
      >
        <div class="page-content">
          <component
            :is="getComponentByUrl(tab.url)"
            :businessId="props.businessId"
            :projectId="props.projectId"
            :collectionId="props.collectionId"
            :domainMenuId="props.domainMenuId"
            :domainId="currentDomainId"
          />
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script setup>
import { ref, onMounted, defineExpose, defineProps, watch } from 'vue'
import ClientDeviceMonitorSystemMonitorSystem from "@/components/clientViews/ClientDeviceMonitorSystemMonitorSystem1.vue";
import ClientDeviceMonitorSystemMonitorOperation from "@/components/clientViews/ClientDeviceMonitorSystemMonitorOperation.vue";
import ClientDeviceMonitorSystemMonitorAlarm from "@/components/clientViews/ClientDeviceMonitorSystemMonitorAlarm.vue";
//import ClientDeviceMonitorSystemMonitorSetup from "@/components/clientViews/ClientDeviceMonitorSystemMonitorSetup.vue";
//import ClientDeviceMonitorSystemMonitorAdvanced from "@/components/clientViews/ClientDeviceMonitorSystemMonitorAdvanced.vue";

import { ElMessage } from "element-plus";
import { useI18n } from "vue-i18n";
import {projectDomainList} from "@/api/ProjectManger";

const { t } = useI18n();

// 响应式数据
const activeTab = ref('1')
const slaveTabs = ref([
  { name: '1', label: t('message.ClientProjectMonitorSystemMonitoring.configuration') },
  { name: '2', label: t('message.ClientProjectMonitorSystemMonitoring.operation') },
  { name: '3', label: t('message.ClientProjectMonitorSystemMonitoring.alarm') },
  { name: '5', label: t('message.ClientProjectMonitorSystemMonitoring.setup') },
  { name: '6', label: t('message.ClientProjectMonitorSystemMonitoring.advanced') }
])

// 其他设备tab（如果有的话）
const otherTabs = ref([
  //{url:"ClientDeviceMonitorSystemMonitorOperation", label: "CX", id: 6 },
  //{url:"ClientDeviceMonitorSystemMonitorOperation", label: "Engr Setup", id: 7 }
]);

// 组件映射
const componentMap = {
  'graph': ClientDeviceMonitorSystemMonitorSystem,
  'operation': ClientDeviceMonitorSystemMonitorOperation,
  'alarm': ClientDeviceMonitorSystemMonitorAlarm
}

// 定义 props
const props = defineProps({
  projectId: {
    type: [String, Number],
    required: true
  },
  businessId: {
    type: [String, Number],
    required: true
  },  
  collectionId: {
    type: [String, Number],
    required: true
  },
  domainMenuId: {
    type: [String, Number],
    required: true
  },
  projectName: {
    type: String,
    default: ''
  }
})

// 使用 props 数据
const currentBusinessId = ref(props.businessId);
const currentProjectId = ref(props.projectId);
const currentCollectionId = ref(props.collectionId);
const currentDomainMenuId = ref(props.domainMenuId); 
const currentDomainId = ref(activeTab.value);

//加载Domain
const LoadDomainLabel = async () => {
  try {
    const params = {
      all: 0,          //1为查询所有，其它为按条件查
      projectId: Number(currentProjectId.value),      
      businessId: Number(currentBusinessId.value),
      collectionId:Number(currentCollectionId.value),
      companyId: undefined,
      name: undefined,
      pageNum: 1,
      pageSize: 1000,
    };

    const res = await projectDomainList(params);
    if(!res.success) {
      ElMessage.error(res?.msg);  
      return;
    }
    
    // 检查是否有数据
    if (!res.data.list || res.data.list.length === 0) {
      otherTabs.value = [];      
   //   ElMessage.warning(t('message.ClientProjectMonitorSystemMonitoring.noData'));
      return;
    }
    otherTabs.value = res.data.list
                    .filter(item => item.id > 5)  // 先过滤：只保留id大于5的项
                    .map(item => ({
                      id: item.id,
                      url: item.url,
                      label: item.name
                    }));
            
  } catch (error) {
    console.error('加载业务选项失败:', error);
    ElMessage.error(t('message.ClientProjectMonitorSystemMonitoring.loadFailed'));
  } 
}


const isFirstLoad = ref(true);
watch(
  [
    () => props.projectId,
    () => props.collectionId, 
    () => props.domainMenuId,
    () => props.businessId
  ],
  async (newValues, oldValues) => {
    const [newProjectId, newCollectionId, newDomainMenuId,  newBusinessId] = newValues;
    const [oldProjectId, oldCollectionId, oldDomainMenuId,  oldBusinessId] = oldValues || [];
    
    
    // ElMessage.error(`${props.collectionId}-currentCollectionId-${currentCollectionId.value} watch--systemMonitor1`);
    console.log('🔍 监听器触发:', {
      新值: newValues,
      旧值: oldValues,
      时间: new Date().toLocaleTimeString()
    });
    
    console.log('📊 详细检查每个值:', {
      newProjectId: { 值: newProjectId, 类型: typeof newProjectId, 是否为空: !newProjectId },
      newCollectionId: { 值: newCollectionId, 类型: typeof newCollectionId, 是否为空: !newCollectionId },
      newDomainMenuId: { 值: newDomainMenuId, 类型: typeof newDomainMenuId, 是否为空: !newDomainMenuId },   
      newBusinessId: { 值: newBusinessId, 类型: typeof newBusinessId, 是否为空: !newBusinessId }
    });

    // 检查条件判断
    const allValuesExist = newProjectId && newCollectionId && newDomainMenuId;
    console.log('✅ 所有值都存在?', allValuesExist);
    
     // 首次加载时跳过，让 onMounted 来处理
    if (isFirstLoad.value) {
      isFirstLoad.value = false;
      // 不在 watch 中处理首次加载
      return;
    }
    
    // 后续的 props 变化才处理
 

    if (allValuesExist) {
      const isPropsChanged = 
        newProjectId !== oldProjectId || 
        newCollectionId !== oldCollectionId || 
        newDomainMenuId !== oldDomainMenuId || 
        newBusinessId !== oldBusinessId;
      
      console.log('🔄 属性是否变化?', {
        是首次执行: !oldValues,
        属性变化: isPropsChanged,
        最终条件: !oldValues || isPropsChanged
      });
      
      if (!oldValues || isPropsChanged) {

        console.log('🚀 执行更新逻辑...');
        try {
      //    ElMessage.info(`开始更新: collectionId=${newCollectionId}`);
          
          // 这里执行你的更新逻辑
          currentProjectId.value = props.projectId;
          currentCollectionId.value = props.collectionId;
          currentDomainMenuId.value = props.domainMenuId; 
          currentDomainId.value =  activeTab.value; // 注意这里
          currentBusinessId.value = props.businessId;
          if (newProjectId>0 && newCollectionId>0 && newDomainMenuId>0) {
            await LoadDomainLabel();
          }
          //ElMessage.error(`${props.collectionId}-currentCollectionId-${currentCollectionId.value} watch--systemMonitor2`);
          console.log('🎉 更新完成:', {
            currentProjectId: currentProjectId.value,
            currentCollectionId: currentCollectionId.value,
            currentDomainMenuId: currentDomainMenuId.value,
            currentDomainId: currentDomainId.value,
            currentBusinessId: currentBusinessId.value
          });
           
          
        } catch (error) {
          console.error('❌ 监听props变化时加载数据失败:', error);                   
        }
      } else {
        console.log('⏸️ 跳过更新: 属性未变化');
      }
    } else {
      console.log('⛔ 条件不满足，缺少的值:', {
        缺少projectId: !newProjectId,
        缺少collectionId: !newCollectionId,
        缺少domainMenuId: !newDomainMenuId,        
        缺少businessId: !newBusinessId
      });
    }
  },
  { immediate: true, deep: true }
);
 

// 监听 activeTab 变化，更新 currentDomainId
watch(activeTab, (newTab) => {
  currentDomainId.value = newTab;  
  console.log('当前domainId更新为:', currentDomainId.value)
})

const handleTabChange = (name) => {
  console.log('切换到标签:', name)
}

const getComponentByUrl = (url) => {
  return componentMap[url] || null
}

const renderTabLabel = (tab) => {
  return tab?.label || ''
}

// 暴露方法给父组件
defineExpose({
  handleTabChange
})

onMounted(async () => {
   // 在 onMounted 中处理首次加载
  if (props.projectId> 0 && props.collectionId> 0 && props.domainMenuId> 0) {
    await LoadDomainLabel();
  }
  console.log('初始化 domainId:', currentDomainId.value)
})
</script>

<style scoped>
.monitor-container {
  padding: 0px;
  background: #f5f7fa;  
  height: 100%;  
  overflow: hidden;
}
.page-content {
  height: 100%;
  overflow: hidden;
}

:deep(.el-tabs--left) {
  min-height: 10px;
  height: 100%;
}

:deep(.el-tabs--left .el-tabs__header.is-left) {
  width: 100px; /* 减小宽度以适应4个汉字 */
  background: #f8f9fa;
  border-right: 1px solid #e4e7ed;
}

:deep(.el-tabs--left .el-tabs__active-bar.is-left) {
  right: 0;
  left: auto;
  width: 3px;
}

:deep(.el-tabs--left .el-tabs__item.is-left) {
  text-align: center; /* 改为居中对齐 */
  padding: 8px 4px; /* 减小内边距 */
  border-bottom: 1px solid #e4e7ed;
  /* 限制文字显示：最多4个汉字，超过换行 */
  white-space: normal;
  word-break: break-all;
  word-wrap: break-word;
  line-height: 1.3;
  min-height: 50px; /* 适当减小最小高度 */
  max-height: 60px; /* 限制最大高度 */
  display: flex;
  align-items: center;
  justify-content: center; /* 内容居中 */
  height: auto !important;
  /* 限制每行最多4个汉字 */
  width: 100%;
  box-sizing: border-box;
}

:deep(.el-tabs--left .el-tabs__item.is-left.is-active) {
  background: #ecf5ff;
  color: #409eff;
  font-weight: 500;
}

:deep(.el-tabs--left .el-tabs__item.is-left:hover) {
  background: #ecf5ff;
  color: #409eff;
}

:deep(.el-tabs__content) {
  padding: 0px;
  height: 100%;
  overflow: hidden;
}

:deep(.el-tab-pane) {
  height: 100%;
  overflow: hidden;
}

/* 针对标签文本的特殊处理 - 限制每行最多4个汉字 */
:deep(.el-tabs--left .el-tabs__item.is-left .el-tabs__item-content) {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: left;
  /* 限制每行字符数 - 4个汉字大约8个英文字符宽度 */
  max-width: 8ch;
  overflow: hidden;
  word-break: break-all;
  hyphens: auto;
}

/* 确保标签文本垂直居中且限制行数 */
:deep(.el-tabs--left .el-tabs__item.is-left span) {
  display: inline-block;
  vertical-align: middle;
  width: 100%;
  text-align: left;
  /* 限制最多显示2行 */
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  line-height: 1.3;
  max-height: 2.6em; /* 2行高度 */
}

/* 响应式设计 */
@media (max-width: 768px) {
  :deep(.el-tabs--left .el-tabs__header.is-left) {
    width: 70px; /* 移动端进一步减小宽度 */
  }
  
  .monitor-container {
    padding: 10px;
  }
  
  :deep(.el-tabs--left .el-tabs__item.is-left) {
    padding: 6px 3px;
    font-size: 13px;
    min-height: 45px;
    max-height: 55px;
  }
  
  :deep(.el-tabs--left .el-tabs__item.is-left span) {
    font-size: 12px;
    -webkit-line-clamp: 2; /* 移动端保持2行 */
    max-height: 2.4em;
  }
}

/* 针对超长文本的额外处理 */
@media (max-width: 480px) {
  :deep(.el-tabs--left .el-tabs__header.is-left) {
    width: 65px;
  }
  
  :deep(.el-tabs--left .el-tabs__item.is-left) {
    padding: 5px 2px;
    font-size: 12px;
    min-height: 40px;
    max-height: 50px;
  }
  
  :deep(.el-tabs--left .el-tabs__item.is-left span) {
    font-size: 11px;
    -webkit-line-clamp: 2;
    max-height: 2.2em;
  }
}

/* 英文环境下的特殊处理 */
:deep(.el-tabs--left .el-tabs__item.is-left[lang="en"] span) {
  font-size: 11px; /* 英文环境下字体稍小 */
  word-break: break-word;
}

/* 确保激活状态的样式优先级 */
:deep(.el-tabs--left .el-tabs__item.is-left.is-active span) {
  font-weight: 600;
}

/* 鼠标悬停效果优化 */
:deep(.el-tabs--left .el-tabs__item.is-left:hover span) {
  color: inherit;
}

/* 强制换行处理 - 对于超长文本 */
:deep(.el-tabs--left .el-tabs__item.is-left .force-break) {
  word-break: break-all;
  overflow-wrap: break-word;
}
</style>